export default __webpack_public_path__ + "static/media/Present-Cake.8255fe56.jpg";